import React, { useCallback, useLayoutEffect, useState } from 'react';
import Blogs from '../layout/Blogs';
import client from '../modules/axios';
import { API } from '../config/path';
import { Helmet } from 'react-helmet-async';

const App = () => {
  const [meta, setMeta] = useState(null);

  const getMeta = useCallback(() => {
    client
      .get(API.SEO_PAGE + '?page_name=blog')
      .then((response) => {
        const data = response.data.data;

        setMeta(data);
      })
      .catch((_error) => {
        // Snackbar.error(error.statusText);
      });
  }, []);

  useLayoutEffect(() => {
    getMeta();
  }, [getMeta]);

  return (
    <>
      {meta && (
        <Helmet>
          <title>{meta.title ?? 'Indoaddict'}</title>
          <meta name="keyword" content={meta.keyword} />
          <meta name="description" content={meta.description} />

          {meta?.type.map((item, i) => {
            if (meta.value === 'title') {
              return <title key={i}>{item.content}</title>;
            }

            if (item.value === 'canonical') {
              return <link key={i} rel="canonical" href={item.content} />;
            }

            return <meta key={i} {...{ [item.tag_type]: item.value }} content={item.content} />;
          })}
        </Helmet>
      )}
      <Blogs />
    </>
  );
};

export default App;
